import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import RequestSignatureService from "../../services/request-signatures.service";
import { PaginationParamsType } from "../../types/common";

// get request signatures
export const getRequestSignaturesFromApi: any = createAsyncThunk(
  "requestSignatures/getAllRequestSignatures",
  async (params: PaginationParamsType) => {
    const res: any = await RequestSignatureService.getAllRequests(params);
    if (res?.response?.status >= 400) {
      throw new Error(res?.response?.data?.error);
    }
    return res || [];
  }
);

// get approved ratings
export const getApprovedRatingsFromApi: any = createAsyncThunk(
  "requestSignatures/getApprovedRatings",
  async () => {
    const res: any = await RequestSignatureService.getApprovedRatings();
    if (res?.response?.status >= 400) {
      throw new Error(res?.response?.data?.error);
    }
    return res || [];
  }
);

const formData = {
  type: "",
  flightId: [],
  endorsementId: "",
  instructorId: "",
  ratingType: "",
  ratingModal: "",
  signature: "",
};

const initialState: any = {
  requestSignatures: [],
  totalCount: 0,
  createRequestForm: formData,
  approvedRatings: [],
  status: "idle",
  error: null,
};

export const requestSignaturesSlice = createSlice({
  name: "requestSignature",
  initialState,
  reducers: {
    setRequestFormData: (state, action: PayloadAction<any>) => {
      state.createRequestForm = {
        ...state.createRequestForm,
        ...action.payload,
      };
    },

    resetRequestFormData: (state, action: PayloadAction<any>) => {
      state.createRequestForm = formData;
    },
  },
  extraReducers: (builder) => {
    // Get Request Signatures List
    builder.addCase(getRequestSignaturesFromApi.pending, (state, action) => {
      state.status = "loading";
    });
    builder.addCase(getRequestSignaturesFromApi.fulfilled, (state, action) => {
      state.status = "succeeded";
      state.requestSignatures = action.payload?.data;
      state.totalCount = action.payload?.totalCount;
    });
    builder.addCase(getRequestSignaturesFromApi.rejected, (state, action) => {
      state.status = "failed";
      state.error = action?.error?.message || "Something went wrong";
    });
    // Get Approved Ratings List
    builder.addCase(getApprovedRatingsFromApi.pending, (state, action) => {
      state.status = "loading";
    });
    builder.addCase(getApprovedRatingsFromApi.fulfilled, (state, action) => {
      state.status = "succeeded";
      state.approvedRatings = action.payload;
    });
    builder.addCase(getApprovedRatingsFromApi.rejected, (state, action) => {
      state.status = "failed";
      state.error = action?.error?.message || "Something went wrong";
    });
  },
});

export const { setRequestFormData, resetRequestFormData } =
  requestSignaturesSlice.actions;

export const getAllRequestSignatures = (state: RootState) =>
  state.requestSignature.requestSignatures;
export const getRequestSignaturesTotalCount = (state: RootState) =>
  state.requestSignature.totalCount;
  
export const getRequestFormData = (state: RootState) =>
  state.requestSignature.createRequestForm;
export const getApprovedRatingsData = (state: RootState) =>
  state.requestSignature.approvedRatings;

export default requestSignaturesSlice.reducer;
